<template>
  <div class="wrap">
    <div class="title">
      <div class="title_left">库存台账</div>
    </div>
    <div class="originLedgerBox">
      <div class="filtrate">
        <el-autocomplete class="w200 mr20" v-model="goodsName" :fetch-suggestions="querySearchAsync" clearable 
          placeholder="请输入商品进行搜索并选中" @select="handleSelect" value-key='name'>
        </el-autocomplete>
        <span class="dayTit mr10">业务日期:</span>
        <el-date-picker @change="searchPage" class="w140 mr10" type="date" value-format="yyyy-MM-dd"
          v-model="queryLimit.businessStartDate" placeholder="选择起始日期" :picker-options="beforeDate" >
        </el-date-picker>
        至
        <el-date-picker @change="searchPage" v-model="queryLimit.businessEndDate" value-format="yyyy-MM-dd"
          class="w140 ml10 mr20" type="date" placeholder="选择截止日期" :picker-options="afterDate" clearable>
        </el-date-picker>
        <span class="dayTit mr10">经办人:</span>
        <el-input placeholder="请输入经办人" class="w200 seekIpt  mr20" v-model="queryLimit.manager" 
          @keyup.enter.native="searchPage" >
            <i slot="suffix" class="el-input__icon el-icon-search" @click="searchPage"></i>
        </el-input>
      </div>
      <el-divider></el-divider>
      <div class="content">
        <!-- @row-click="openDetail"  -->
        <el-table ref="multipleTable" border stripe :data="tableData.records" tooltip-effect="dark" style="width: 100%">
          <el-table-column prop="goodsName" min-width="180" align='center' label="商品名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="goodsType" min-width="120" align='center' label="商品类型" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="businessType" min-width="120" align='center' label="业务类型" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="supply" min-width="180" align='center' label="供应商" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.supply?scope.row.supply:'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="source" min-width="150" align='center' label="来源" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.source?scope.row.source:'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="date" min-width="180" align='center' label="日期" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="orderSerialNumber" min-width="180" align='center' label="订单号" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="validPeriodDate" min-width="180" align='center' label="保质期" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.validPeriodDate?scope.row.validPeriodDate:'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="batchNo" min-width="120" align='center' label="批次号" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.batchNo?scope.row.batchNo:'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="manager" min-width="120" align='center' label="经办人" show-overflow-tooltip>
          </el-table-column>
          <el-table-column align='center' label="原始库存">
            <el-table-column prop="primevalStockWeight" min-width="100" align='center' label="数量" show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.primevalStockWeight?scope.row.primevalStockWeight:'-'}}
              </template>
            </el-table-column>
            <el-table-column prop="primevalStockUnit" min-width="80" align='center' label="单位" show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.primevalStockUnit?scope.row.primevalStockUnit:'-'}}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column align='center' label="入库">
            <el-table-column prop="stockInWeight" min-width="100" align='center' label="数量" show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.stockInWeight?scope.row.stockInWeight:'-'}}
              </template>
            </el-table-column>
            <el-table-column prop="stockInUnit" min-width="80" align='center' label="单位" show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.stockInUnit?scope.row.stockInUnit:'-'}}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column align='center' label="出库">
            <el-table-column prop="stockOutWeight" min-width="100" align='center' label="数量" show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.stockOutWeight?scope.row.stockOutWeight:'-'}}
              </template>
            </el-table-column>
            <el-table-column prop="stockOutUnit" min-width="80" align='center' label="单位" show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.stockOutUnit?scope.row.stockOutUnit:'-'}}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column align='center' label="结存数量">
            <el-table-column prop="balanceWeight" min-width="100" align='center' label="数量" show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.balanceWeight?scope.row.balanceWeight:'-'}}
              </template>
            </el-table-column>
            <el-table-column prop="balanceUnit" min-width="80" align='center' label="单位" show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.balanceUnit?scope.row.balanceUnit:'-'}}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="操作" min-width="80" fixed="right">
            <template slot-scope="scope">
              <a href="javascript:;" class="operate-a" v-if="scope.row.orderId!=''"
                @click="openDetail(scope.row)">详情</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-box">
        <el-pagination background @size-change="pageSizeChange" @current-change="pageCurrentChange"
          :current-page="queryLimit.pageNum" :page-sizes="[20,50, 100, 200]" :page-size="queryLimit.pageSize"
          layout="total,prev, pager, next, sizes, jumper" :total="tableData.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import * as api from "api/report";
  export default {
    data() {
      return {
        goodsName: '',
        queryLimit: {
          pageNum: 1,
          pageSize: 20,
          goodsCode: "",
          manager: '',
          businessStartDate: '',
          businessEndDate: '',
        },
        tableData: {},
        beforeDate: {
          disabledDate: (time) => {
            let endDate = new Date(this.queryLimit.businessEndDate);
            if (this.queryLimit.businessEndDate) {
              let date = new Date(this.getLastMonth(this.queryLimit.businessEndDate, 's'))
              return time.getTime() > endDate - 8.64e7 || time.getTime() < date
            }
          }
        },
        afterDate: {
          disabledDate: (time) => {
            let startDate = new Date(this.queryLimit.businessStartDate);
            if (this.queryLimit.businessStartDate) {
              let date = new Date(this.getLastMonth(this.queryLimit.businessStartDate, 'e'))
              return time.getTime() < startDate - 8.64e7 || time.getTime() > date
            }
          }
        },
      };
    },
    methods: {
      openDetail(row, event, column) {
        this.$router.push({
          name: 'sourceFill.goodsFillInfo',
          query: {
            type: 'detail',
            id: row.orderId,
            name: '库存台账'
          }
        })
      },
      pageCurrentChange(current) {
        this.queryLimit.pageNum = current;
        this.getPageData();
      },
      pageSizeChange(size) {
        this.queryLimit.pageSize = size;
        this.searchPage();
      },
      querySearchAsync(queryString, cb) {
        this.queryLimit.goodsCode = '';
        if(queryString==''){
          this.searchPage();
        }
        api.goodsListAll({
          current: 1,
          size: 20,
          goodsName: queryString
        }).then(res => {
          if (res.code === 200) {
            let arr = []
            res.data.records.map(obj => {
              arr.push({
                name: `${obj.name}(${obj.unit})`,
                id: obj.id
              })
            })
            cb(arr);
          } else {
            cb([]);
          }
        })
      },
      handleSelect(item) {
        this.queryLimit.goodsCode = item.id;
        this.searchPage();
      },
      searchPage() {
        this.queryLimit.pageNum = 1;
        this.getPageData();

      },
      resetAll() {
        this.queryLimit = {
          pageNum: 1,
          goodsName: "",
          endDate: '',
          startDate: '',
          pageSize: this.queryLimit.pageSize
        };
        this.getPageData();
      },
      async getPageData() {
        if (this.goodsName && this.queryLimit.goodsCode == '') {
          this.$message({
            message: "你输入的商品未被匹配出，请重新输入搜索并必须选中商品！",
            type: "warning"
          });
          return;
        }
        if (this.queryLimit.businessEndDate && !this.queryLimit.businessStartDate) {
          this.$message({
            message: "请选择开始日期",
            type: "warning"
          });
          return;
        }
        if (this.queryLimit.businessStartDate && !this.queryLimit.businessEndDate) {
          this.$message({
            message: "请选择截止日期",
            type: "warning"
          });
          return;
        }
        console.log(api)
        await api.originLedger_(this.queryLimit).then(res => {
          if (res.code === 200) {
            this.tableData = res.data
          }
        })
      },
      getLastMonth(d, type) {
        let now = new Date(d);
        let year = now.getFullYear(); //getYear()+1900=getFullYear()
        let month = now.getMonth() + 1; //0-11表示1-12月
        let day = now.getDate();
        let month30 = '';
        if (parseInt(month) < 10) {
          month = "0" + month;
        }
        if (parseInt(day) < 10) {
          day = "0" + day;
        }
        if (type == 's') {
          if (parseInt(month) == 1) { //如果是1月份，则取上一年的12月份
            month30 = (parseInt(year) - 1) + '-12-' + day;
            return month30;
          }
          let preSize = new Date(year, parseInt(month) - 1, 0).getDate(); //上月总天数
          if (preSize < parseInt(day)) { //上月总天数<本月日期，比如3月的30日，在2月中没有30
            month30 = year + '-' + month + '-01';
            return month30;
          }
          if (parseInt(month) <= 10) {
            month30 = year + '-0' + (parseInt(month) - 1) + '-' + day;
            return month30;
          } else {
            month30 = year + '-' + (parseInt(month) - 1) + '-' + day;
            return month30;
          }
        } else {
          if (parseInt(month) == 12) { //如果是12月份，取下一年
            month30 = (parseInt(year) + 1) + '-01-' + day;
            return month30;
          }
          let preSize = new Date(year, parseInt(month) + 1, 0).getDate(); //下月总天数
          if (preSize < parseInt(day)) { //下月总天数<本月日期，比如2月的28日，
            month30 = year + '-' + (parseInt(month) + 1) + '-01';
            return month30;
          }
          if (parseInt(month) <= 10) {
            month30 = year + '-0' + (parseInt(month) + 1) + '-' + day;
            return month30;
          } else {
            month30 = year + '-' + (parseInt(month) + 1) + '-' + day;
            return month30;
          }
        }


      },
      getNowDay() {
        let date = new Date();
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let today = y + '-' + m + '-' + d
        this.queryLimit.businessStartDate = today;
        this.queryLimit.businessEndDate = today
      },
    },
    mounted() {
      this.getPageData();
      this.getNowDay()
    }
  };
</script>

<style scoped lang="scss">
  .wrap {
    width: calc(100% - 40px);
    padding: 0 20px;
    height: 100%;
    background: #f6f6f6;

    .title {
      height: 60px;
      line-height: 60px;

      .title_left {
        font-size: 20px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        width: 50%;
        height: 100%;
      }
    }

    .innerBox {
      width: calc(100% - 60px);
      padding: 20px 30px;
      height: calc(100% - 125px);
      background: #fff;
      border-radius: 10px;
      overflow: scroll;

      .filtrate {
        vertical-align: center;
        color: #666666;
        font-size: 12px;

        .year {
          font-size: 12px;
          line-height: 18px;
        }

        .dayTit {
          margin-right: 8px;
        }
      }

      .operate {
        .left {
          float: left;

          .pl {
            margin-left: 0;
          }
        }

        .right {
          float: right;
        }
      }
    }

    .pagination-box {
      text-align: right;
      margin-top: 20px;
    }
  }
</style>
<style>
  .originLedgerBox .table-div .el-table__body-wrapper {
    overflow-x: scroll !important;
  }
</style>